<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- old header -->
<!-- <header class="header">
  <div class="container-fluid">
    <div class="primary-header justify-content-md-between d-md-flex">
      <ul class=" d-flex justify-content-between d-md-block">
        <li><a href="/livewell" id="digital">Live Well</a></li>
        <li><a href="/travel" id="travel">Travel Well</a></li>
        <li><a href="/shopwell" id="store">Shop Well</a></li>
      </ul>
      <ul class=" d-none d-md-block">
        <li><a routerLink="/partners">Partners</a></li>
        <li>
          <a (click)="opensignupmodal()" *ngIf="!globalServices.isLoggedIn">
            Get 30 Days Free
            </a>
        </li>
      </ul>
    </div>
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand cursorHand" (click)="logoClick()"><img src="https://www.mylifewell.com/assets/images/logo/300.png" alt=""></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" routerLink="/about-us">About Us</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" routerLink="/workwell">Corporate Wellness</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.mylifewell.com/blogs/">Blog</a>
          </li>
        </ul>

        <div class="navbar-text navbar-controls d-md-flex align-items-md-center">
        <div class="global-search" [ngClass]="{'open-search':openSearch}" >
          
        </div>              
          <div class="available user-settings-menu d-md-inline-block" id="user-settings-menu" *ngIf="globalServices.isLoggedIn">
            <a  (click)="showprofilemenu($event, 'user-setting')">
              <span class="prof-name-txt cursorHand" >
                <span class="user-profile-icn" *ngIf='globalServices.imgSrc'>
                  <img [src]="globalServices.imgSrc" alt="prof-img" >
                </span>{{globalServices.firstname}}
              </span>
            </a>
            <ul class="user-setting  text-left d-none cursorHand" id="user-setting">
              <li><a routerLink="home">My Dashboard</a></li>
              <li><a href="/myaccount">My Account</a></li>
              <li><a (click)="logOut()">Log Out</a></li>
            </ul>
          </div>
          <a *ngIf="!globalServices.isLoggedIn"  (click)="openloginmodal()" class="btn login-btn"><span>Log In</span></a>
         
          <a *ngIf="!globalServices.isLoggedIn"  (click)="opensignupmodal()" class="btn signup-btn colorWhite">
            Sign Up
          </a>
          <a href="/cart"><i class="icon-cart d-none d-md-inline-block"></i></a>
          <span class="notification d-none d-md-flex">{{globalServices.cartquantity}}</span>
        </div>
      </div>
      <div class="user-mob d-md-none"> 
        <a href="/cart"><i class="icon-cart"></i></a>
        <span class="notification">{{globalServices.cartquantity}}</span>
      </div>
    </nav>
  </div>
  
  <div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
  </div>
</header> -->


<!-- New Header -->
<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- old header -->
<!-- <header class="header">
  <div class="container-fluid">
    <div class="primary-header justify-content-md-between d-md-flex">
      <ul class=" d-flex justify-content-between d-md-block">
        <li><a href="/livewell" id="digital">Live Well</a></li>
        <li><a href="/travel" id="travel">Travel Well</a></li>
        <li><a href="/shopwell" id="store">Shop Well</a></li>
      </ul>
      <ul class=" d-none d-md-block">
        <li><a routerLink="/partners">Partners</a></li>
        <li>
          <a (click)="opensignupmodal()" *ngIf="!globalServices.isLoggedIn">
            Get 30 Days Free
            </a>
        </li>
      </ul>
    </div>
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand cursorHand" (click)="logoClick()"><img src="https://www.mylifewell.com/assets/images/logo/300.png" alt=""></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" routerLink="/about-us">About Us</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" routerLink="/workwell">Corporate Wellness</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.mylifewell.com/blogs/">Blog</a>
          </li>
        </ul>

        <div class="navbar-text navbar-controls d-md-flex align-items-md-center">
        <div class="global-search" [ngClass]="{'open-search':openSearch}" >
          
        </div>              
          <div class="available user-settings-menu d-md-inline-block" id="user-settings-menu" *ngIf="globalServices.isLoggedIn">
            <a  (click)="showprofilemenu($event, 'user-setting')">
              <span class="prof-name-txt cursorHand" >
                <span class="user-profile-icn" *ngIf='globalServices.imgSrc'>
                  <img [src]="globalServices.imgSrc" alt="prof-img" >
                </span>{{globalServices.firstname}}
              </span>
            </a>
            <ul class="user-setting  text-left d-none cursorHand" id="user-setting">
              <li><a routerLink="home">My Dashboard</a></li>
              <li><a href="/myaccount">My Account</a></li>
              <li><a (click)="logOut()">Log Out</a></li>
            </ul>
          </div>
          <a *ngIf="!globalServices.isLoggedIn"  (click)="openloginmodal()" class="btn login-btn"><span>Log In</span></a>
         
          <a *ngIf="!globalServices.isLoggedIn"  (click)="opensignupmodal()" class="btn signup-btn colorWhite">
            Sign Up
          </a>
          <a href="/cart"><i class="icon-cart d-none d-md-inline-block"></i></a>
          <span class="notification d-none d-md-flex">{{globalServices.cartquantity}}</span>
        </div>
      </div>
      <div class="user-mob d-md-none"> 
        <a href="/cart"><i class="icon-cart"></i></a>
        <span class="notification">{{globalServices.cartquantity}}</span>
      </div>
    </nav>
  </div>
  
  <div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
  </div>
</header> -->


<!-- New Header -->
<header class="header">
  <div class="primary-header text-center" *ngIf="globalServices?.isActivePlan == 0 && globalServices.firstname && this.globalServices.isLoggedIn">
      <p class="text-capitalize cursorHand" style="margin-bottom: 0px;"  (click)="moveToMembershipPage()">
        Welcome back, {{ globalServices.firstname }}! Let's complete your app membership.
      </p>
  </div>
  <div class="container-fluid">
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand cursorHand">
        <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="mylifewell" (click)="logoClick()">
      </a>
      <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation" (click)="navigationToggleButton()">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <form class="header-searchform d-none d-md-block">
        <div class="form-group">
          <select class="form-control search-control" id="searchSelect1" (change)="searchInArea($event)">
            <option value="all">All</option>
            <option value="digital">Live Well</option>
            <option value="travel">Travel Well</option>
            <option value="shop">Shop well</option>
          </select>
          <input type="text" class="form-control" id="searchtxtSame" aria-describedby="emailHelp" placeholder="" name="searchText" [(ngModel)]="searchText" (keyup)="searchTextEnter($event)">
        </div>
        <button type="submit" class="search-btn" (click)="searchNow(searchText)">
          <img src="assets/images/search-icn.png" alt="">
        </button>
      </form>
      <div class="collapse navbar-collapse show" >
        <ul class="navbar-nav mr-auto">
          <li class="d-md-none">
            <a class="navbar-brand cursorHand">
              <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="">
            </a>
            <span class="close-icon" (click)="navigationToggleButton()">
              <img src="assets/images/close-icn.png" alt="">
            </span>
          </li>
          <li class="has-submenu menuListItem" (click)="addOrRemoveClass(0)">
            <a class="nav-link active" id="digital" (click)="liveWellSectionClick($event)">
              <!-- href="/livewell" -->
              Live Well 
              <i class="icon-arrow d-md-none"></i>
            </a>
            <div class="menu-lavel-2 livewell-lavel">
              <ul class="submenu">
                <li class="has-submenu cursorHand" (click)="moveToClasses($event)">
                  <span class="menue-img d-none d-md-block"><img src="assets/images/livewell-menu01.jpg" alt=""></span>
                  <a class="nav-link text-uppercase" >
                    Classes 
                    <i class="icon-arrow"></i>
                  </a>
                </li>
                <li class="has-submenu cursorHand" (click)="moveToPrograms($event)">
                  <span class="menue-img d-none d-md-block"><img src="assets/images/livewell-menu02.jpg" alt=""></span>
                  <a class="nav-link text-uppercase" >
                    Programs
                    <i class="icon-arrow"></i>
                  </a>
                </li>
                <li class="has-submenu cursorHand" (click)="moveToOneToOne($event)">
                  <span class="menue-img d-none d-md-block"><img src="assets/images/livewell-menu03.jpg" alt=""></span>
                  <a class="nav-link text-uppercase" >
                    1:1 Training 
                    <i class="icon-arrow"></i>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <!-- (click)="addOrRemoveClass(1)" -->
          <li class="has-submenu menuListItem" id="travelWellId" > 
            <a class="nav-link"  id="travel" (click)="travelWellSectionClick($event)">
              <!-- href="/travel" -->
              Travel Well 
              <i class="icon-arrow d-md-none"></i>
            </a>
            <div class="menu-lavel-2">
              <ul class="submenu">
                <li class="has-submenu">
                  <a class="nav-link TravelSubMenu active" (click)="menuLavel3AddOrRemoveClassForTravelClub($event);addActiveClasstoThisNavLink($event, 0);">
                    Travel Club 
                    <i class="icon-arrow d-md-none"></i>
                  </a>
                </li>
                <li class="has-submenu">
                  <a class="nav-link TravelSubMenu " (click)="menuLavel3AddOrRemoveClassForDestination($event);addActiveClasstoThisNavLink($event, 1);">
                    Destinations
                    <i class="icon-arrow d-md-none"></i>
                  </a>
                </li>
                <li class="has-submenu">
                  <a class="nav-link TravelSubMenu" (click)="menuLavel3AddOrRemoveClassForWellnessStyle($event);addActiveClasstoThisNavLink($event, 2);">
                    Wellness Styles 
                    <i class="icon-arrow d-md-none"></i>
                  </a>
                </li>
              </ul>

              <div class="menu-lavel-3  navbar-collapse show" id="menuLavel3AddOrRemoveClassIdForDestination">
                <ul class="navbar-nav mr-auto">
                  <li class="d-md-none" (click)="menuLavel3AddOrRemoveClassForDestination($event)">
                    <a class="back-btn">
                      <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-long-arrow-left fa-w-14 fa-2x">
                        <path fill="#5d5d5d" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z" class="">
                        </path>
                      </svg>
                      Destinations
                    </a>
                  </li>
                  <li class="has-submenu active-menu" *ngFor="let country of resCountryData?.unitedStateData; let i = index;" >
                    <a class="nav-link cursorHand"  id="travel" (click)="navigateFromCountries(country ,country['regionSlug'],country.slug);clickOnCountryInDestinationsInMobile(i);">
                      {{ country['name'] }}
                      <i class="icon-arrow d-md-none"></i>
                    </a>
                    <div class="menu-lavel-2 hideByDefaultOnMobile DestinationCountrySubMenu">
                      <ul class="submenu">
                        <li class="has-submenu" *ngFor="let states of resCountryData?.unitedStateData[0]?.stateData">
                          <a [href]="getlinkfromstate(states ,country['regionSlug'],country.slug)"  target="_blank"> 
                            {{ states['name'] }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="has-submenu active-menu" *ngFor="let country of resCountryData?.destinationData; let i = index;">
                    <a class="nav-link cursorHand"  id="travel" (click)="navigateFromCountries(country ,country?.slug, country?.countryData[0]?.slug);">
                      {{ country['regionName'] }}
                      <i class="icon-arrow d-md-none"></i>
                    </a>
                    <div class="menu-lavel-2 hideByDefaultOnMobile DestinationRegionSubMenu">
                      <ul class="submenu">
                        <li class="has-submenu" *ngFor="let states of country?.countryData">
                          <a [href]="getlinkfromstate(states ,country.slug,states['slug'])"   target="_blank"> 
                            {{states['name']}} 
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
                <div class="menu-gallery" *ngIf="">
                  <a href="#" class="item d-block">
                    <img src="assets/images/gallery-img01.jpg" />
                  </a>
                  <a href="#" class="item d-block">
                    <img src="assets/images/gallery-img02.jpg" />
                  </a>
                </div>
              </div>
              <div class="menu-lavel-3  navbar-collapse show" id="menuLavel3AddOrRemoveClassIdForWellnessStyle">
                <ul class="navbar-nav mr-auto">
                  <li class="d-md-none" (click)="menuLavel3AddOrRemoveClassForWellnessStyle($event)">
                    <a class="back-btn" >
                      <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-long-arrow-left fa-w-14 fa-2x">
                        <path fill="#5d5d5d" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z" class="">
                        </path>
                      </svg>
                      Wellness Styles
                    </a>
                  </li>
                  <li class="has-submenu active-menu" *ngFor="let actData of wellnessStyleData?.data; let in = index;" >
                    <a class="nav-link"  id="travel" (click)="goToTravelWellnessStyle(actData ,'programCat')">
                      {{ actData.name }}
                      <i class="icon-arrow d-md-none"></i>
                    </a>
                    <div class="menu-lavel-2">
                      <ul class="submenu">
                        <li class="has-submenu " *ngFor="let subCatList of actData['subCategoryData']">
                          <a [href]="navigateToProduct(subCatList ,'programSubCat')" target="_blank" class="nav-link active">
                            {{subCatList.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
                <div class="menu-gallery" *ngIf="">
                  <a href="#" class="item d-block">
                    <img src="assets/images/gallery-img01.jpg" />
                  </a>
                  <a href="#" class="item d-block">
                    <img src="assets/images/gallery-img02.jpg" />
                  </a>
                </div>
              </div>
              <div class="menu-lavel-3  navbar-collapse show" id="menuLavel3AddOrRemoveClassIdForTravelClub" *ngIf="">
                <ul class="navbar-nav mr-auto">
                  <li class="d-md-none" (click)="moveToJoinTravelClub()">
                    <a class="back-btn">
                      <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-long-arrow-left fa-w-14 fa-2x">
                        <path fill="#5d5d5d" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z" class="">
                        </path>
                      </svg>
                      Travel Club
                    </a>
                  </li>
                </ul>
              </div>
              <div class="destination-mega d-none d-md-block">
                <div class="row">
                  <!-- Travel Club Desktop Right Side Menu -->
                  <div class="col-md-12 d-flex justify-content-between flex-wrap align-items-start cursorHand" *ngIf="showTravel && !showDestinations" (click)="moveToJoinTravelClub()">
                    <img src="../../assets/images/travelClubBanner/banner2.png" style="width: 100%;max-height: 600px;">
                  </div> 
                  <div class="col-md-9 d-flex justify-content-between flex-wrap align-items-start" *ngIf="resCountryData && showDestinations && !showTravel">
                    <div class="cate-coln" *ngFor="let country of resCountryData['unitedStateData']; let i = index;">
                      <h6 class="des-country cursorHand" (click)="navigateFromCountries(country ,country['regionSlug'],country.slug)">
                        {{country['name']}}
                      </h6>
                      <ul class="state-list">
                        <li *ngFor="let states of resCountryData['unitedStateData'][0]['stateData']">
                          <a [href]="getlinkfromstate(states ,country['regionSlug'],country.slug)"  target="_blank"> 
                            {{states['name']}}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="cate-coln" *ngFor="let country of resCountryData['destinationData']; let i = index;">
                      <h6 class="des-country cursorHand" (click)="navigateFromCountries(country , country?.slug, country?.countryData[0]?.slug)">
                        {{ country['regionName'] }}
                      </h6>
                      <ul class="state-list">
                        <li *ngFor="let states of country['countryData']">
                          <a [href]="getlinkfromstate(states ,country.slug,states['slug'])"   target="_blank"> 
                            {{states['name']}} 
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-9 d-flex justify-content-between flex-wrap align-items-start" *ngIf="wellnessStyleData && !showDestinations && !showTravel">
                    <div class="cate-coln" *ngFor="let actData of wellnessStyleData['data']" >
                      <h6 class="des-country cursorHand" (click)="goToTravelWellnessStyle(actData ,'programCat')">
                        {{actData.name}}
                      </h6>
                      <ul class="state-list">
                        <li *ngFor="let subCatList of actData['subCategoryData']">
                          <a [href]="navigateToProduct(subCatList ,'programSubCat')" target="_blank">
                            {{subCatList.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="">
                    <div class="mega-gallery">
                      <a href="#" class="item d-block">
                        <img src="assets/images/destination-img01.jpg" />
                      </a>
                      <a href="#" class="item d-block">
                        <img src="assets/images/destination-img02.jpg" />
                      </a>
                      <a href="#" class="item d-block">
                        <img src="assets/images/destination-img03.jpg" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="destination-mega lifestyle-mega d-none" *ngIf="">
                <div class="row">
                  <div class="col-md-3">
                    <h6 class="des-country">Active Adventures</h6>
                    <ul class="state-list">
                      <li><a href="#">Biking</a></li>
                      <li><a href="#">Diving</a></li>
                      <li><a href="#">Hiking-Treking-Running</a></li>
                      <li><a href="#">Horse & Ranch</a></li>
                      <li><a href="#">Kayaking</a></li>
                      <li><a href="#">Rafting</a></li>
                      <li><a href="#">Surfing</a></li>
                      <li><a href="#"><img src="assets/images/new-zealand-banner.jpg" alt=""></a></li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <h6 class="des-country">Special Interests</h6>
                    <ul class="state-list">
                      <li><a href="#">Affordable Trips</a></li>
                      <li><a href="#">Anniversary Retreats</a></li>
                      <li><a href="#">Christmas Retreats</a></li>
                      <li><a href="#">Couples only</a></li>
                      <li><a href="#">Executive Retreats</a></li>
                      <li><a href="#">Family Trips</a></li>
                      <li><a href="#">Luxury Retreats</a></li>
                      <li><a href="#">New Year's Trips</a></li>
                      <li><a href="#">Rest & Relaxation retreats</a></li>
                      <li><a href="#">Solo</a></li>
                      <li><a href="#">Thanks Giving Retreats</a></li>
                      <li><a href="#">Valentine Day Retreats</a></li>
                      <li><a href="#">Weekend</a></li>
                      <li><a href="#">Women's Only</a></li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <h6 class="des-country">Healing &amp; Therapy</h6>
                    <ul class="state-list">
                      <li><a href="#">Ayurveda</a></li>
                      <li><a href="#">Hydrotherapy</a></li>
                    </ul>
                    <h6 class="des-country">Yoga and Meditation</h6>
                    <ul class="state-list">
                      <li><a href="#">Meditation</a></li>
                      <li><a href="#">yoga</a></li>
                    </ul>
                    <h6 class="des-country">Health, Weight &amp; Fitness</h6>
                    <ul class="state-list">
                      <li><a href="#">Fitness Retreats</a></li>
                      <li><a href="#">Health Retreats</a></li>
                      <li><a href="#">Weight Loss</a></li>
                    </ul>
                    <h6 class="des-country">Spa &amp; Massage</h6>
                    <ul class="state-list">
                      <li>
                        <a href="#">Anti Aging</a>
                      </li>
                      <li><a href="#">Personal Care</a></li>
                      <li><a href="#">Spa Retreats</a></li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <div class="mega-gallery">
                      <a href="#" class="item d-block">
                        <img src="assets/images/mega-menu-banner.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- (click)="addOrRemoveClass(2)" -->
          <li class="has-submenu menuListItem" >
            <!-- (click)="shopWellSectionClick($event)" -->
            <a class="nav-link" id="store2"  (click)="shopWellSectionClick($event)">
              <!-- href="/shopwell" -->
              Shop well 
              <i class="icon-arrow d-md-none"></i>
            </a>
            <div class="menu-lavel-2 shop-mega">
              <ul class="submenu d-md-none">
                <li class="has-submenu" *ngIf=""> 
                  <a class="nav-link active " *ngFor="let i of shopCategories" (click)="menuLavel3AddOrRemoveClass($event)">
                    {{ i?.name }}
                    <i class="icon-arrow d-md-none"></i>
                    <ul class="">
                      <li *ngFor="let j of i?.subcategory">
                        <a [href]="subcategoryOfShopClicked(i,j)" (click)="subCategoryOfShopClick($event)">
                          {{ j?.name }}
                        </a>
                      </li>
                    </ul>
                  </a>
                </li>
                <li class="has-submenu coming-soontxt" *ngIf="">
                  Coming Soon
                </li>
              </ul>
                 <!-- SHOPWELL BAR OPEN IN MOBILE ---- INSIDE SHOPWELL -->
                 <div class="menu-lavel-3  navbar-collapse show" id="menuLavel3AddOrRemoveClassIdForShopwell">
                  <ul class="navbar-nav mr-auto">
                    <li class="d-md-none" (click)="menuLavel3AddOrRemoveClassForShopwell($event)">
                      <a class="back-btn" >
                        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-long-arrow-left fa-w-14 fa-2x">
                          <path fill="#5d5d5d" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z" class="">
                          </path>
                        </svg>
                        Shopwell
                      </a>
                    </li>
                    <li class="has-submenu active-menu" *ngFor="let i of shopCategories;" >
                      <a class="nav-link"  (click)="categoryOfShopClicked(i)">
                        {{ i?.name }}
                        <i class="icon-arrow d-md-none"></i>
                      </a>
                      <div class="menu-lavel-2">
                        <ul class="submenu">
                          <li class="has-submenu " *ngFor="let j of i?.subcategory">
                            <a [href]="subcategoryOfShopClicked(i,j)"  target="_blank"> 
                              {{ j?.name }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              <div class="destination-mega d-none d-md-block">
                <div class="row">
                  <div class="col-md-9 shopcate-wrp" >
                    <div class="shopcate-list" *ngFor="let i of shopCategories">
                      <h6 class="des-country cursorHand"  (click)="categoryOfShopClicked(i)">
                        {{ i?.name }}
                      </h6>
                      <ul class="state-list">
                        <li *ngFor="let j of i?.subcategory">
                          <a [href]="subcategoryOfShopClicked(i,j)">
                            {{ j?.name }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-9 shopcate-wrp" *ngIf="">
                    <div class="shopcate-list coming-soontxt">
                      Coming Soon
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="">
                    <div class="mega-gallery">
                      <a href="/shopwell" class="item d-block">
                        <img src="assets/images/destination-img01.jpg" />
                      </a>
                      <a href="/shopwell" class="item d-block">
                        <img src="assets/images/destination-img02.jpg" />
                      </a>
                      <a href="/shopwell" class="item d-block">
                        <img src="assets/images/destination-img03.jpg" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <!-- <a class="nav-link" routerLink="/workwell" id="store">
              CORPORATE WELLNESS
            </a> -->
            <a class="nav-link" (click)="goToUrl('https://business.mylifewell.com/')" id="store">
              B2B Solutions
            </a>
          </li>
          <li>
            <a class="nav-link" href="/membership/app" id="store">
              membership
            </a>
          </li>
          <li *ngIf="globalServices.isLoggedIn" class="d-md-none">
            <a class="nav-link" routerLink="/profile">
              My Profile
            </a>
          </li>
          <li class="d-md-none">
            <a class="nav-link" href="/contact">
              Help & Support
            </a>
          </li>
          <li class="signin d-md-none">
            <a *ngIf="!globalServices.isLoggedIn"  (click)="openSectionForLogin();openloginmodal();" class="btn signin-btn">
              Sign In
            </a>
            <a *ngIf="globalServices.isLoggedIn"  (click)="logOut()" class="btn signin-btn">
              Logout
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar-text d-none navbar-controls d-md-flex align-items-md-center">
        <div class="global-search" [ngClass]="{'open-search':openSearch}" >
          
        </div>              
        <div class="available user-settings-menu d-md-inline-block" id="user-settings-menu" *ngIf="globalServices.isLoggedIn">
          <!-- <a  (click)="showprofilemenu($event, 'user-setting')"> -->
            <a  (click)="openSectionForLogout()">
            <span class="prof-name-txt cursorHand" >
              <span class="user-profile-icn" *ngIf='globalServices.imgSrc'>
                <img [src]="globalServices.imgSrc" alt="prof-img" >
              </span>
              {{globalServices.firstname}}
            </span>
          </a>
          <ul class="user-setting  text-left d-none cursorHand" id="user-setting">
            <li><a routerLink="home">My Dashboard</a></li>
            <li><a href="/myaccount">My Account</a></li>
            <li><a (click)="logOut()">Log Out</a></li>
          </ul>
        </div>
        <span class="desk-notification d-none d-md-inline-block">
          <a href="/cart"><i class="icon-cart"></i></a>
          <span class="notification d-none d-md-flex">
            {{globalServices.cartquantity}}
          </span>
        </span>
        <a *ngIf="!globalServices.isLoggedIn"  (click)="openSectionForLogin();openloginmodal();" class="btn login-btn d-none d-md-inline-block">
          <span>Sign In</span>
        </a>
        <!-- Befor login pop up -->
        <div class="login-reg-popup d-none d-md-block" id="newSignInPopUp">
          <div class="popup-head d-flex justify-content-between align-items-center">
            <span class="urser-icn">
              <img src="assets/images/user-icn.png" alt="">
            </span>
            <div class="info">
              <div class="log-reg-txt cursorHand">
                <a (click)="openloginmodal();openSectionForLogin()" >
                  Login
                </a>/
                <a (click)="openloginmodal();openSectionForLogin();" >
                  Register
                </a>
              </div>
              <a routerLink="/membership/app"  class="btn join-btn" *ngIf="!globalServices?.isLoggedIn">
                Join MyLife Club
              </a>
            </div>
            <i class="icon-arrow"></i>
          </div>
          <ul class="user-nav-list">
            <!-- <li><a href="#" class="text-capitalize"><i class="icon-order"></i><span>My Orders</span></a></li> -->
            <!-- <li><a href="#" class="text-capitalize"><i class="icon-wishlist"></i><span>Wishlist</span></a></li> -->
            <!-- <li><a href="#" class="text-capitalize"><i class="icon-consultation"></i><span>My Consultation</span></a></li> -->
            <li>
              <a href="/about-us" class="text-capitalize">
                <i class="icon-consultation"></i>
                <span>
                  About Us
                </span>
              </a>
            </li>
            <li>
              <a href="/contact" class="text-capitalize">
                <i class="icon-support"></i>
                <span>
                  Help & Support
                </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- After login pop up -->
        <div class="login-reg-popup d-none d-md-block" id="AfterNewSignInPopUp">
          <div class="popup-head d-flex justify-content-between align-items-center">
            <span class="urser-icn">
              <!-- <img src="assets/images/user-icn.png" alt=""> -->
              <img [src]="globalServices.imgSrc" alt="prof-img" >
            </span>
            <div class="info">
              <!-- <div class="log-reg-txt cursorHand">
                <a (click)="logOut()" >
                  Logout
                </a>
              </div> -->
              <div class="log-reg-txt cursorHand">
                <a  >
                  Hi {{globalServices.firstname}}
                </a>
              </div>
              <a routerLink="/membership/app"  class="btn join-btn" *ngIf="!globalServices?.isLoggedIn">
                Join MyLife Club
              </a>
            </div>
            <i class="icon-arrow"></i>
          </div>
          <ul class="user-nav-list">
            <li>
              <a routerLink="/bookings" class="text-capitalize">
                <i class="icon-order"></i>
                <span>
                  My Orders
                </span>
              </a>
            </li>
            <li>
              <a routerLink="/wishlist" class="text-capitalize">
                <i class="icon-wishlist"></i>
                <span>
                  Wishlist
                </span>
              </a>
            </li>
            
            <li>
              <a routerLink="/profile" class="text-capitalize">
                <i class="icon-profile"></i>
                <span>
                  My Profile
                </span>
              </a>
            </li>
            <li>
              <a href="/contact" class="text-capitalize">
                <i class="icon-support"></i>
                <span>
                  Help & Support
                </span>
              </a>
            </li>
            <li (click)="logOut()" >
              <a class="text-capitalize cursorHand">
                <i class="icon-consultation"></i>
                <span>
                  Logout
                </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- <a *ngIf="!globalServices.isLoggedIn"  (click)="opensignupmodal()" class="btn signup-btn colorWhite d-none d-md-inline-block">
          Sign Up
        </a> -->
        
      </div>
      <!-- <div class="user-mob d-md-none"> 
        <a href="/cart"><i class="icon-cart"></i></a>
        <span class="notification">{{globalServices.cartquantity}}</span>
      </div> -->
    </nav>
    <div class="mobile-nav-strip d-flex align-items-center justify-content-between d-md-none">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation" (click)="navigationToggleButton()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="user-mob d-md-none"> 
        <span class="search-mob">
          <a (click)="searchNow(searchText)" class="search-icn">
            <img src="assets/images/search-icn.png" alt="">
          </a>
        </span>
        <a href="/cart"><i class="icon-cart"></i></a>
        <span class="notification">{{globalServices.cartquantity}}</span>
      </div>

    </div>
    <form class="header-searchform mob-header-search d-md-none">
      <div class="form-group">
        <select (change)="searchInArea($event)"  class="form-control search-control">
          <option value="all">All</option>
          <option value="digital">Live Well</option>
          <option value="travel">Travel Well</option>
          <option value="shop">Shop well</option>
        </select>
        <input type="text"  id="searchtxt"  class="form-control"  name="searchText" [(ngModel)]="searchText" (keyup)="searchTextEnter($event)">
      </div>
      <button type="submit" class="search-btn" >
        <img src="assets/images/search-icn.png" alt="">
      </button>
    </form>
  </div>
  
  <div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
  </div>
</header>


